<template>
    <vue-qrcode :options="{ width: 200 }" :value="encodedKey" />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import VueQrcode from '@chenfengyuan/vue-qrcode';

@Component({
    name: 'SoftDeviceQrcode',
    components: {
        VueQrcode,
    },
})
export default class CardQrcodeDescription extends Vue {
    @Prop({ default: 'SIO' }) issuer: string;
    @Prop({ default: '' }) uid: string;
    @Prop({ default: '' }) secret: string;

    get encodedKey() {
        return `otpauth://totp/${this.issuer}:${this.uid}?secret=${this.secret}&issuer=${this.issuer}`;
    }
}
</script>
